import { usesWaistLength } from "@/lib/taxonomy";

const KEY = "ycs_size_prefs";

export function emptyPrefs() {
  return { clothing: { women: {}, men: {}, kids: {} }, shoes: {} };
}

export function loadLocalPrefs() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY)) || {};
    return {
      clothing: { women: {}, men: {}, kids: {}, ...(raw.clothing || {}) },
      shoes: { ...(raw.shoes || {}) },
    };
  } catch {
    return emptyPrefs();
  }
}

export function saveLocalPrefs(prefs) {
  try { localStorage.setItem(KEY, JSON.stringify(prefs)); } catch {}
}

function hasAny(prefs) {
  if (!prefs) return false;
  const c = prefs.clothing || {};
  const clothingSet = ["women", "men", "kids"].some((d) => c[d] && Object.values(c[d]).some(Boolean));
  const shoesSet = prefs.shoes && Object.values(prefs.shoes).some(Boolean);
  return clothingSet || shoesSet;
}
export const hasAnySizes = hasAny;

// Account prefs (from /auth/me) win when present & non-empty; otherwise device (localStorage).
export function effectivePrefs(user) {
  const acct = user && user.size_prefs;
  if (hasAny(acct)) {
    return {
      clothing: { women: {}, men: {}, kids: {}, ...(acct.clothing || {}) },
      shoes: { ...(acct.shoes || {}) },
    };
  }
  return loadLocalPrefs();
}

// Which filter params should be applied for a given browse context.
// ctx: { type:'shoes', audience } OR { type:'apparel', dept, garment }
export function resolveSizeParams(prefs, ctx) {
  if (!prefs || !ctx) return {};
  if (ctx.type === "shoes") {
    const s = prefs.shoes?.[ctx.audience];
    return s ? { size: s } : {};
  }
  if (ctx.type === "apparel") {
    const c = prefs.clothing?.[ctx.dept] || {};
    if (usesWaistLength(ctx.dept, ctx.garment)) {
      const out = {};
      if (c.waist) out.waist = c.waist;
      if (c.inseam) out.inseam = c.inseam;
      return out;
    }
    return c.top ? { size: c.top } : {};
  }
  return {};
}
